import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Row,
  Col,
  Input,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';

import {
  SpH5,
  SpError,
} from 'components/DesignKit';

type Props = {
  paymentInfo: Object,
};

const PaymentNote = (props: Props, ref) => {
  const {
    paymentInfo,
  } = props;

  const [, forceUpdate] = useState();
  const [note, setNote] = useState(paymentInfo.note);
  const simpleValidator = useRef(new SimpleReactValidator());

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      paymentInfo.note = note;
      return true;
    },
  }));

  return (
    <>
      <div>
        <Row>
          <Col span={3} className="mb-2">
            <SpH5>Payment Heading</SpH5>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Input
              type="text"
              maxLength={30}
              onChange={(e) => { setNote(e.currentTarget.value); paymentInfo.note = e.currentTarget.value; }}
              value={note}
            />
            <SpError>
              {simpleValidator.current.message('payment heading', note, 'required')}
            </SpError>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default forwardRef(PaymentNote);
